import { Checkbox, getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import React from 'react'
import Trns from 'src/localization/Trns'
import { TransactionExpenseCategoryStatus } from 'src/models/transaction.models'
import { css } from 'styled-components'

interface ExpenseCategoryStatusFilterProps {
  expenseCategoryStatusesSet: Set<string>
  handleExpenseCategoryStatusesSelection: (status: string) => Set<string>
}

const ExpenseCategoryStatusFilter: React.FC<ExpenseCategoryStatusFilterProps> = ({
  expenseCategoryStatusesSet,
  handleExpenseCategoryStatusesSelection,
}) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        <Trns source={'Expense Category Status'} />
      </div>
      <Checkbox
        label={<Trns source={'Attached'} />}
        onClick={(): void => {
          handleExpenseCategoryStatusesSelection(
            TransactionExpenseCategoryStatus.Attached,
          )
        }}
        isSelected={expenseCategoryStatusesSet.has(
          TransactionExpenseCategoryStatus.Attached,
        )}
      />
      <Checkbox
        label={<Trns source={'Missing'} />}
        onClick={(): void => {
          handleExpenseCategoryStatusesSelection(
            TransactionExpenseCategoryStatus.Missing,
          )
        }}
        isSelected={expenseCategoryStatusesSet.has(
          TransactionExpenseCategoryStatus.Missing,
        )}
      />
    </div>
  )
}

export default ExpenseCategoryStatusFilter
